var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    [
      _vm.severityOverrideProps.number
        ? _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "d-flex flex-no-wrap justify-space-between",
                  attrs: {
                    color: _vm.severityOverrideProps.color,
                    elevation: "12",
                  },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "v-card-title",
                        [
                          _c(
                            "v-icon",
                            { staticClass: "pr-3", attrs: { large: "" } },
                            [
                              _vm._v(
                                " mdi-" +
                                  _vm._s(_vm.severityOverrideProps.icon) +
                                  " "
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                `${_vm.severityOverrideProps.title}: ${_vm.severityOverrideProps.number}`
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-card-text", [
                        _vm._v(_vm._s(_vm.severityOverrideProps.subtitle)),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled:
                              _vm.filter.tagFilter &&
                              _vm.filter.tagFilter.indexOf(
                                "severityoverride"
                              ) !== -1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("show-severity-overrides")
                            },
                          },
                        },
                        [_vm._v(" Filter to Severity Overrides ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }